// extracted by mini-css-extract-plugin
var _1 = "GroupView-module__animateUploadProgressBarWidth--F9EtQ";
var _2 = "GroupView-module__animatedBackground--FkCec";
var _3 = "GroupView-module__asideHeader--fyihR";
var _4 = "GroupView-module__container--KKgmM";
var _5 = "GroupView-module__controlsContainer--MUw_e";
var _6 = "GroupView-module__description--zGvEs";
var _7 = "GroupView-module__isEditing--uN5TZ";
var _8 = "GroupView-module__titleRow--_UsEX";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "asideHeader", _4 as "container", _5 as "controlsContainer", _6 as "description", _7 as "isEditing", _8 as "titleRow" }
